// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext, useContext } from 'react';
// A part rendered outside `TableRoot` reads this default (auto layout) instead of throwing. It is also
// the value the existing `Table` resets to at its root, so a Table nested inside an atomic grid cell
// renders from auto layout rather than inheriting the outer table's.
export const defaultTableContext = {
    isGrid: false,
    gridTemplateColumns: undefined,
};
const TableContext = createContext(defaultTableContext);
export const TableContextProvider = TableContext.Provider;
export function useTableContext() {
    return useContext(TableContext);
}
//# sourceMappingURL=context.js.map